"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFromFirebaseReference = exports.getPartialFromReference = exports.getListenerFromFirebaseReference = exports.extractFromSnapshot = void 0;
const valueIsNullOrUndef_1 = __importDefault(require("../../typeAssertions/valueIsNullOrUndef"));
const extractFromSnapshot = (snapshot) => {
    const value = snapshot === null || snapshot === void 0 ? void 0 : snapshot.val();
    if (!value) {
        return null;
    }
    return value;
};
exports.extractFromSnapshot = extractFromSnapshot;
const getListenerFromFirebaseReference = (firebaseReference) => (listener) => {
    const internalListener = (snapshot) => {
        const value = (0, exports.extractFromSnapshot)(snapshot);
        listener(value);
    };
    firebaseReference.on('value', internalListener);
    return {
        unsubscribe: () => {
            firebaseReference.off('value', internalListener);
        },
    };
};
exports.getListenerFromFirebaseReference = getListenerFromFirebaseReference;
const getPartialFromReference = async (firebaseReference, children) => {
    const valuePromises = children.map((child) => firebaseReference.child(child).once('value'));
    const snapshots = await Promise.all(valuePromises);
    const valueObject = snapshots.reduce((accum, snapshot, index) => (Object.assign(Object.assign({}, accum), { [children[index]]: snapshot.val() || null })), {});
    let hasNoValues = true;
    Object.values(valueObject).forEach((paramValue) => {
        if (!(0, valueIsNullOrUndef_1.default)(paramValue)) {
            hasNoValues = false;
        }
    });
    if (hasNoValues) {
        return null;
    }
    return valueObject;
};
exports.getPartialFromReference = getPartialFromReference;
const getFromFirebaseReference = async (firebaseReference) => {
    const snapshot = await firebaseReference.once('value');
    return (0, exports.extractFromSnapshot)(snapshot);
};
exports.getFromFirebaseReference = getFromFirebaseReference;
